/**
 * Event Constants - Single Source of Truth für Event-Typen
 *
 * Diese Datei wird sowohl von Server als auch Client importiert,
 * um Konsistenz bei Event-IDs zu gewährleisten.
 *
 * Verwendet CommonJS für Node.js-Kompatibilität.
 * Create-React-App kann CommonJS problemlos importieren.
 */

// =============================================================================
// GAME EVENTS - Spielzüge
// =============================================================================

const GAME_EVENT = {
  // Karten spielen
  PLAY_OPEN: 'play_open',           // Eröffnet Stich
  PLAY_RESPOND: 'play_respond',     // Antwortet auf Stich
  PLAY_HIGHER: 'play_higher',       // Kann höher

  // Stich-Ergebnis
  TRICK_WIN: 'trick_win',           // Gewinnt Stich
  TRICK_RESET: 'trick_reset',       // Neuer Stich (alle passen)

  // Andere Aktionen
  PASS: 'pass',                     // Passt
  DRAW: 'draw',                     // Zieht Karte(n)
  DRAW_WITH_SEAL: 'draw_with_seal', // Zieht Karte mit Siegel

  // Finish
  FINISH: 'finish',                 // Ist raus (ohne Stichgewinn)
  FINISH_WIN: 'finish_win',         // Gewinnt letzten Stich und ist raus

  // Runden
  ROUND_START: 'round_start',       // Runde beginnt
  ROUND_END: 'round_end',           // Runde endet
  PARTIE_END: 'partie_end',         // Partie endet

  // Exchange (Kartentausch)
  EXCHANGE_GIVE: 'exchange_give',       // Spieler gibt Karten ab (nur für Beteiligte)
  EXCHANGE_RECEIVE: 'exchange_receive', // Spieler erhält Karten (nur für Beteiligte)
  EXCHANGE_COMPLETE: 'exchange_complete', // Tausch abgeschlossen (für Zuschauer)

  // INSTANT-Siegel
  SEAL_INSTANT: 'seal_instant',     // INSTANT-Siegel getriggert
  SEAL_NO_EFFECT: 'seal_no_effect', // Siegel ohne Effekt (Bedingung nicht erfüllt)
  SEAL_DUMP: 'seal_dump',           // Ballast-Siegel: Karte abgeworfen

  // HAND-Siegel
  HAND_SEAL: 'handSeal',            // HAND-Siegel getriggert
  BEATEN_SEAL: 'beatenSeal',        // Siegel wurde geschlagen (auf verlierender Karte)
  SEAL_ACTIVATED: 'sealActivated',  // Siegel aktiviert (wartet auf Trigger)

  // Sabotage & Traps
  SABOTAGE: 'sabotage',             // Saboteur-Joker verkauft
  TRAP: 'trap',                     // Stolperfalle-Joker verkauft

  // Curse Seal Effects
  SCHNORRER_ULI: 'schnorrerUli',    // Schnorrer-Uli: Originator bekommt Punkte

  // Joker Effects
  JOKER_BONUS: 'jokerBonus',         // Joker gibt Bonus beim Karten-Erhalt

  // Wheel Effects
  WHEEL_START: 'wheelStart',         // Glücksrad wird gedreht
  WHEEL_RESULT: 'wheelResult',       // Glücksrad-Ergebnis

  // Magic Card Effects
  MAGIC_CARD_DRAWN: 'magicCardDrawn', // Zauberkarte gezogen (triggert Minispiel)

  // Minigame Effects
  MINIGAME_REWARD: 'minigameReward',   // Minispiel-Belohnung (Punkte, Münzen, etc.)

  // Highscore
  TRICK_HIGHSCORE: 'trickHighscore',   // Neuer Stich-Highscore aufgestellt
};

// =============================================================================
// EFFECT UNITS - Einheiten für Effekte
// =============================================================================

const EFFECT_UNIT = {
  POINTS: 'points',
  COINS: 'coins',
  MULT: 'mult',
  CARDS: 'cards'
};

// =============================================================================
// EVENT KATEGORIEN
// =============================================================================

const EVENT_CATEGORY = {
  GAME: 'game',     // Spielzüge (play, pass, draw, etc.)
  SEAL: 'seal',     // Siegel-Effekte
  JOKER: 'joker',   // Joker-Effekte
  SYSTEM: 'system'  // System-Events (Rundenstart, etc.)
};

module.exports = {
  GAME_EVENT,
  EFFECT_UNIT,
  EVENT_CATEGORY
};
